import { CoreIcon } from '../core-icon';
import streetviewColorSVG from '../../assets/icons/streetview-color.svg';
import type { IconProps } from '../core-icon';

export const StreetviewColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={streetviewColorSVG} {...props} />;
};
